const stats = [
  { value: '120+', label: '收录作品' },
  { value: '9', label: '本季新番' },
  { value: '每周', label: '持续整理' },
  { value: '全端', label: '手机可看' },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[560px] md:min-h-[720px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20anime%20inspired%20fantasy%20landscape%20illustration%20with%20glowing%20fairy%20lights%20and%20floating%20glowing%20particles%20over%20a%20twilight%20gradient%20sky%20in%20warm%20coral%20and%20amber%20tones%2C%20distant%20floating%20islands%20and%20a%20mystical%20forest%20silhouette%2C%20highly%20detailed%20digital%20art%2C%20cinematic%20wide%20composition%2C%20dark%20calm%20negative%20space%20in%20the%20center%20for%20text%20overlay%2C%20no%20people%2C%20no%20text&width=1920&height=1080&seq=yaojing-hero-main-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/45 to-foreground-950/75"></div>

      <div className="relative w-full px-4 md:px-8 py-28 md:py-32">
        <div className="mx-auto max-w-4xl flex flex-col items-center text-center gap-6 animate-rise">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 border border-background-50/30 px-4 py-1.5 text-xs md:text-sm font-medium text-background-50 backdrop-blur">
            <i className="ri-play-circle-line"></i>
            妖精动漫 · 在线看番场景
          </span>

          <h1 className="font-heading text-3xl sm:text-4xl md:text-6xl text-background-50 leading-tight">
            妖精动漫在线看番
            <br className="hidden sm:block" />
            新番推荐与无修资源一站备齐
          </h1>

          <p className="max-w-2xl text-sm md:text-lg text-background-100/90 leading-relaxed">
            从本季连载到往季补番，从无修资源索引到里番合集分类，这里的资源列表按喜好逐条整理。
            追更热门连载还是补完冷门作品，都能在下面的分区里找到对应入口。
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-3 pt-2">
            <a
              href="#recommend"
              className="inline-flex items-center justify-center gap-2 w-full sm:w-auto rounded-md bg-primary-500 px-6 py-3 text-sm md:text-base font-medium text-background-50 whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors dark:text-foreground-950"
            >
              <i className="ri-sparkling-line"></i>
              开始挑选新番
            </a>
            <a
              href="#schedule"
              className="inline-flex items-center justify-center gap-2 w-full sm:w-auto rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm md:text-base font-medium text-background-50 whitespace-nowrap cursor-pointer hover:bg-background-50/20 transition-colors backdrop-blur"
            >
              <i className="ri-calendar-event-line"></i>
              查看追番时间表
            </a>
          </div>
        </div>

        <dl className="mx-auto mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 max-w-4xl">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-50/25 bg-background-50/10 backdrop-blur px-4 py-3 md:py-4 text-center"
            >
              <dt className="font-heading text-xl md:text-3xl text-background-50">{s.value}</dt>
              <dd className="mt-1 text-xs md:text-sm text-background-100/85">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}